module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeftLight-a333aeb8cc21c4e6e62d00bfa7904f68.png";